import { roleAdmin, roleManager, roleSuperAdmin } from '@/mixins/roles';

const OrganisationToursGuides = () => import('@/pages/organisation-tours/guides.vue');

export default [
  {
    path: '/organisation-tours/guides',
    name: 'OrganisationToursGuides',
    meta: {
      auth: {
        roles: [roleAdmin, roleSuperAdmin, roleManager],
        forbiddenRedirect: '/forbidden',
      },
      title: [
        'Экскурсии мир',
        'Гиды',
      ],
    },
    component: OrganisationToursGuides,
  },
  {
    path: '/organisation-tours/guides/:id',
    name: 'OrganisationToursGuidesForm',
    meta: {
      auth: {
        roles: [roleAdmin, roleSuperAdmin, roleManager],
        forbiddenRedirect: '/forbidden',
      },
      title: [
        'Экскурсии мир',
        'Гиды',
      ],
    },
    component: OrganisationToursGuides,
  },
];
